/**
 * The body of `POST /api/dashboard/results` for "My office network" (CU-869fmjzrh D2). Only what changes the data
 * travels; Min/Avg/Max, Total/Per day, Tier/Providers, Rows, Find, Show change are local. Office and site groups go by
 * their id: the server resolves them with the owner rule. Pure and alias-free.
 */
import { toCompact } from '../../../@services/dates.js'
import { carsBody } from '../../../@services/cars.js'
import { COMPARE_BODY } from './capture.js'

export const REPORT_TYPE = 'my-office-network'

/** The lengths a request asks: the lengths view's columns; the provider view reuses them when its length is one */
export function requestLengths(view, shownLengths) {
	if (view.v === 'pickup') return [view.lor]
	if (view.v === 'provider') return shownLengths.includes(view.lor) ? [...shownLengths] : [view.lor]
	return [...shownLengths]
}

export function buildRequestBody({ view, pickup, capture, currency, shownLengths }) {
	return {
		reportType: REPORT_TYPE,
		// the provider view asks the lengths view's data (the server answers from its cache), but says it is the
		// provider view: the usage log counts each view (CA 26)
		view: view.v,
		showBy: view.v === 'pickup' ? view.by : 'day',
		meAs: view.me,
		compare: COMPARE_BODY[view.cmp],
		offices: {
			countries: [...(view.countries || [])], types: [...(view.types || [])],
			ids: view.officeGroup ? [] : [...(view.offices || [])], groupId: view.officeGroup || null,
		},
		lengths: requestLengths(view, shownLengths),
		sites: { ids: view.siteGroup ? [] : [...(view.sites || [])], groupId: view.siteGroup || null },
		currency: currency ?? null,
		startPickupDate: toCompact(pickup.from),
		endPickupDate: toCompact(pickup.to),
		startBookingDate: toCompact(capture.from),
		endBookingDate: toCompact(capture.to),
		...carsBody(view),
	}
}
